var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "template-card change-info" }, [
    _c(
      "h3",
      { staticClass: "dmv-text dmv-text-primary dmv-text-large title" },
      [
        _vm._v(
          "\n        " +
            _vm._s(_vm.resource("DmVisualizer_Templates_Your_Data_Title")) +
            "\n    "
        )
      ]
    ),
    _vm._v(" "),
    _c("p", { staticClass: "dmv-text dmv-text-secondary" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.resource("DmVisualizer_Templates_Your_Data_Text_Part1")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "dmv-text dmv-text-secondary" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.resource("DmVisualizer_Templates_Your_Data_Text_Part2")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn btn-lg btn-outline-primary change-info-btn",
        on: {
          click: function($event) {
            return _vm.$emit("trigger-change-info")
          }
        }
      },
      [
        _vm._v(
          "\n         " +
            _vm._s(
              _vm.resource("DmVisualizer_Templates_Change_Data_Button_Text")
            ) +
            "\n    "
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }